module.exports = __webpack_public_path__ + "static/media/chiller_control_cool_icon.ebc30035.svg";